import { TranscribeAudioResponseSchema } from './transcribe-audio.schema';
/**
 * Transcribe Audio Feature
 * Accepts an audio file (multipart/form-data) and returns transcribed text.
 *
 * Voice input backs every AI surface that takes dictation, so its gate is the
 * tenant's master `enableAI` alone — the same gate the app-chat endpoints run.
 * A per-assistant flag (`enableBliksy`) must not decide it, or a tenant
 * entitled to an app chat would lose the microphone inside it.
 */ export const transcribeAudioContract = {
    method: 'POST',
    path: '/api/v2/transcribe-audio',
    description: 'Transcribe audio to text (multipart/form-data)',
    responseSchema: TranscribeAudioResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid or missing audio file',
            401: 'Unauthorized - invalid or missing token',
            403: 'AI disabled for the tenant, or the user may not create recordings',
            413: 'Audio file too large (max 25MB)'
        }
    }
};

//# sourceMappingURL=transcribe-audio.contract.js.map